import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SessionSetup, SessionFormData } from '@components/session/SessionSetup';
import { sessionStorage } from '@services/storage/session-storage';
import { Snackbar } from '@components/common/Snackbar';
import { logger } from '@utils/logger';

export function SessionSetupPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: SessionFormData) => {
    try {
      setLoading(true);
      setError(null);

      const session = await sessionStorage.create(data);
      logger.info('Session created:', session.sessionId);

      navigate(`/session/${session.sessionId}/observe`);
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : t('sessionSetup.failedCreate');
      logger.error('Session creation error:', err);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {t('sessionSetup.title')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('sessionSetup.subtitle')}
        </Typography>
      </Box>

      <Paper sx={{ p: 3 }}>
        <SessionSetup onSubmit={handleSubmit} loading={loading} />
      </Paper>

      <Snackbar
        open={!!error}
        message={error || ''}
        severity="error"
        onClose={() => setError(null)}
      />
    </Container>
  );
}
